module.exports = __webpack_public_path__ + "img/filters_header.696435b0.svg";